import { canUseDOM } from 'exenv';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import get from 'lodash/get';
import assign from 'lodash/assign';
import Cookies from 'js-cookie';
import matchMediaDesktop from '../../../../utils/client_util';
import Ad from '../../ad/ad';
import Recommender from '../../recommender/recommender';
import RelatedPosts from '../../related_posts/related_posts';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';
import { isAdvertorial } from '../../../../views/components/advertorial/advertorial';
import SiderailVideoModuleReactJW from '../../siderail_video_module/siderail_video_module_reactjw';

export default class Sidebar extends Component {
  constructor() {
    super();
    this.sidebarVideo = false;
    this.buildClassName = this.buildClassName.bind(this);
  }

  buildClassName() {
    const { fullPageAdvertorial, isVideoPost } = this.props;
    const className = ['post__promotion'];

    if (isVideoPost) {
      className.push('post__promotion--video');
    }

    if (fullPageAdvertorial) {
      className.push('post__promotion--advertorial');
    }

    return className.join(' ');
  }

  renderSidebar() {
    const {
      config,
      post,
      isFirstPost,
      combinedAdModel,
      isDesktop,
      related,
      fullPageAdvertorial,
      totalAdCount,
      isLongPost,
      isVideoPost
    } = this.props;
    const totalAds = isLongPost && !isVideoPost ? totalAdCount : 1;
    const ads = [];
    const readTime = get(post, 'readTime');
    const hasPosterVideo = get(post, 'posterVideo.feedId');
    const isListPage = get(this.props, 'posts.length') > 1;

    if (config.initialPageLoad || !canUseDOM || !matchMediaDesktop()) {
      return null;
    }

    // Note: having fc_rev_content means the user is from international
    const videoSidebar =
      isFirstPost &&
      !hasPosterVideo &&
      !Cookies.get('fc_rev_content') &&
      !isVideoPost &&
      !isAdvertorial(get(post, 'tags')) &&
      !isListPage;

    if (videoSidebar) {
      Cookies.set('alreadySeenRightRailPlayer', '1', { expires: 1 });
      this.sidebarVideo = true;

      ads.push(
        <div
          className="post__promotion post__promotion--non-sticky"
          key={`sidebar-nonsticky-${post.id}`}
        >
          <Ad
            {...combinedAdModel}
            noLazyLoad={true}
            pos="atf"
            name="flexibleportrait"
            canRefresh={true}
            readTime={readTime}
            pageNum={get(this.props, 'pageNum')}
          />
        </div>,
        <div
          className="post__promotion"
          key={`post-ad-${post.id}-1`}
          id={`post-ad-${post.id}-1`}
        >
          {/* eslint-disable no-nested-ternary */}
          <Sticky
            top={100}
            bottomBoundary={`#post-ad-${post.id}-1`}
            enabled={isDesktop || false}
          >
            <Fragment>
              <div className="post__relative" key={`sidebar-video-${post.id}`}>
                <SiderailVideoModuleReactJW
                  config={config}
                  type="rightrail"
                  playerid="2fyG0pBE"
                  playlistId="dOytm2y2"
                  pos="newmultiplayer"
                  readTime={readTime}
                />
              </div>{' '}
              <Ad
                {...combinedAdModel}
                noLazyLoad={false}
                pos="btf"
                name="flexiblehalfpage_1"
                canRefresh={true}
                readTime={readTime}
                pageNum={get(this.props, 'pageNum')}
              />
            </Fragment>
          </Sticky>
          {/* eslint-enable no-nested-ternary */}
        </div>
      );
    } else {
      for (let i = 0; i < totalAds; i += 1) {
        ads.push(
          <div
            key={i}
            className={this.buildClassName()}
            id={`post-ad-${post.id}-${i}`}
          >
            {/* eslint-disable no-nested-ternary */}
            <Sticky
              top={100}
              bottomBoundary={`#post-ad-${post.id}-${i}`}
              enabled={isDesktop || false}
            >
              <Ad
                {...combinedAdModel}
                noLazyLoad={i === 0 && isFirstPost}
                pos={i === 0 ? 'atf' : 'btf'}
                name={
                  i === 0 && get(this.props, 'post.posterSlideshow')
                    ? 'slideshowhalfpage'
                    : i === 0
                      ? 'flexibleportrait'
                      : `flexiblehalfpage_${i}`
                }
                canRefresh={!!get(this.props, 'post.posterSlideshow')}
                readTime={readTime}
                pageNum={get(this.props, 'pageNum')}
              />
              {i === 0 &&
              isLongPost &&
              !isVideoPost &&
              isAdvertorial(get(post, 'tags')) ? (
                <div className="post__relative">
                  <RelatedPosts
                    config={config}
                    stories={related.map(article =>
                      assign(article, {
                        assetSizes: imageSizesLookup.column
                      })
                    )}
                    fullPageAdvertorial={fullPageAdvertorial}
                  />
                </div>
              ) : null}
              {i === 0 &&
              isLongPost &&
              !isVideoPost &&
              !isAdvertorial(get(post, 'tags')) ? (
                <div className="post__relative post__relative--recommender">
                  <Recommender initialPageLoad={config.initialPageLoad} />
                </div>
              ) : null}
            </Sticky>
            {/* eslint-enable no-nested-ternary */}
          </div>
        );
      }
    }

    return ads;
  }

  render() {
    if (!this.props) {
      return null;
    }

    return (
      <div
        className={`post__sidebar ${
          this.props.isVideoPost ? 'post__sidebar--video' : ''
        }`}
      >
        {this.renderSidebar()}
      </div>
    );
  }
}

Sidebar.defaultProps = {
  related: [],
  isDesktop: false,
  fullPageAdvertorial: false,
  totalAdCount: 2,
  isVideoPost: false,
  isLongPost: false
};

Sidebar.propTypes = {
  config: PropTypes.shape({}).isRequired,
  post: PropTypes.shape({}).isRequired,
  isFirstPost: PropTypes.bool.isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  combinedAdModel: PropTypes.shape({}).isRequired,
  isDesktop: PropTypes.bool,
  fullPageAdvertorial: PropTypes.bool,
  totalAdCount: PropTypes.number,
  isLongPost: PropTypes.bool,
  isVideoPost: PropTypes.bool
};
